import { render } from "./SendRecipesHopperCard.vue?vue&type=template&id=da0162ac"
import script from "./SendRecipesHopperCard.vue?vue&type=script&lang=js"
export * from "./SendRecipesHopperCard.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__